import { Link } from "react-router-dom";

export function Logo({ variant = "dark", className = "" }) {
  const isDark = variant === "dark";
  return (
    <Link to="/" data-testid="logo-home-link" className={`group flex items-center gap-2.5 ${className}`}>
      <img src="/brand/logo-mark.png" alt="PR Pathfinder" className="h-10 w-auto transition-transform group-hover:scale-105" />
      <span className="font-heading text-xl font-extrabold leading-none tracking-tight">
        <span className="text-[#C8102E]">PR</span>{" "}
        <span className={isDark ? "text-[#0F2A4A]" : "text-white"}>Pathfinder</span>
      </span>
    </Link>
  );
}
